// Extra large desktop breakpoint.
export const xlg = 1200;

// Desktop breakpoint.
export const lg = 992;

// Tablet breakpoint.
export const md = 768;

// Mobile breakpoint.
export const sm = 576;
